import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { MapService } from 'src/app/services/map.service';
import { Subscription } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import Croppie from 'croppie';

@Component({
    selector: 'app-creategame',
    templateUrl: './creategame.component.html',
    styleUrls: ['./creategame.component.scss'],
    standalone: false
})
export class CreategameComponent {
  creategameform: FormGroup;
  @Output() updateData: EventEmitter<any> = new EventEmitter();

  gametypelistdata: any;
  gametype: string;

  gamesystemlistdata: any;
  gamesystem: string;

  maplist: any;
  map_id: any;
  user_id: any;
  mapListSubscription: Subscription;

  @ViewChild('map', { read: ElementRef, static: true }) mapElement: ElementRef;
  @ViewChild('croppieElement') croppieElement!: ElementRef;
  croppieInstance!: Croppie;
  defaultBase64Image: string = '';
  map_code: any;
  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (
      this.mapElement &&
      this.mapElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      this.mapService.handleMapContentClick(true, true, false, false);
    } else this.mapService.handleMapContentClick(false, true, false, false);
  }

  constructor(
    private formBuilder: FormBuilder,
    public activeroute: ActivatedRoute,
    public activemodel: NgbActiveModal,
    private dataserv: DataService,
    private mapService: MapService,
    private router: Router,
    private coordinateService: CoordinatesService,
    private toastService: ToastService,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id;
        this.initializeForm();
        this.getmaplist();
        this.productlist();
      }
    
          this.cdr.detectChanges();});

    this.mapListSubscription = this.mapService.mapList$.subscribe(
      (data: any) => {
        if (data) {
          this.maplist = data;
          if (
            this.maplist.length > 0 &&
            !this.creategameform.get('map_id').value
          ) {
            this.map_code = this.maplist[0].map_id;
            this.creategameform.get('map_id').setValue(this.map_code);
          }
          this.cdr.detectChanges();
        } else {
          this.mapService.getMapList();
        }
      },
    );

    this.coordinateService.pointDrawn$.subscribe((data) => {
      if (data) {
        const coordString = data?.join(',');
        this.creategameform.patchValue({
          spawn_location: coordString,
        });

      }
    
          this.cdr.detectChanges();});
  }
  ngAfterViewInit(): void {
    this.mapService.map.setTarget(this.mapElement.nativeElement);
    this.creategameform.get('map_id').valueChanges.subscribe((value) => {
      this.map_code = value;
      this.mapService.removeOldMap();
      this.mapService.loadlayers({ map_id: this.map_code, type: 'Master' });
    
          this.cdr.detectChanges();});
    this.loadDefaultImage();
  }

  initializeForm() {
    this.creategameform = this.formBuilder.group({
      Gamename: ['', [Validators.required]],
      map_id: [this.map_id, [Validators.required]],
      game_type: ['', [Validators.required]],
      game_system: ['', [Validators.required]],
      user_id: [Number(this.user_id), [Validators.required]],
      gamemaster_id: [Number(this.user_id), [Validators.required]],
      spawn_location: ['', [Validators.required]],
      image: [''], // Will be updated with Base64 image

      // Add longitude
    });
  }
  loadDefaultImage() {
    fetch('assets/main/OIP.png')
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const mimeType = blob.type; // Get the MIME type (image/jpeg, image/png, etc.)
          this.defaultBase64Image = `data:${mimeType};base64,${(reader.result as string).split(',')[1]}`;

          // Set the default Base64 image in the form
          this.creategameform.patchValue({ image: this.defaultBase64Image });

          // Initialize Croppie with the default Base64 image
          this.initializeCroppie();
        
          this.cdr.detectChanges();};
        reader.readAsDataURL(blob);
      })
      .catch((error) => console.error('Error loading default image:', error));
  }

  initializeCroppie() {
    if (this.croppieElement?.nativeElement) {
      this.croppieInstance = new Croppie(this.croppieElement.nativeElement, {
        viewport: { width: 150, height: 150, type: 'circle' },
        boundary: { width: 200, height: 200 },
        showZoomer: true,
        enableOrientation: true,
      });

      // Bind the Base64 image to Croppie
      this.croppieInstance.bind({ url: this.defaultBase64Image });
    } else {
      console.error('Croppie element not found');
    }
  }

  cropImage() {
    if (this.croppieInstance) {
      this.croppieInstance
        .result({ type: 'base64', size: 'viewport' })
        .then((croppedBase64: string) => {
          const mimeType = this.defaultBase64Image.split(';')[0].split(':')[1]; // Extract MIME type from default image
          const finalBase64 = `data:${mimeType};base64,${croppedBase64.split(',')[1]}`;
          this.creategameform.patchValue({ image: finalBase64 });
        });
    }
  }

  productlist() {
    this.dataserv.getproductlist('gamemaster').subscribe((data: any) => {
      if (data) {
        this.gamesystemlistdata = data.products.gamemaster.filter(
          (item) => item.type === 'Game System',
        );
        this.gametypelistdata = data.products.gamemaster.filter(
          (item) => item.type === 'GameType',
        );
        this.cdr.detectChanges();
      }
    });
  }

  getmaplist() {
    this.mapService.getMapList(this.user_id, false);
  }

  submit() {
    if (this.creategameform.valid) {
      // Check if form is valid
      this.dataserv.creategame(this.creategameform.value).subscribe((res) => {
        this.toastService.showSuccess(
          'Game Created Successfully !!!',
          'success',
        );
        // Reload the list
        this.updateData.emit(this.creategameform.value);
        this.closemodel();
      
          this.cdr.detectChanges();});
    } else {
      console.error('Form is invalid');
      // Optionally, you can show an error toast here
    }
  }

  closemodel() {
    this.activemodel.close();
  }
}
